<template>
  <router-link
    v-if="visible"
    class="study-planner-sidebar-link"
    :class="{ active, mastery, rail, mobile }"
    :to="{ name: 'studyPlanner#show' }"
    data-test="study-planner-link"
    @click="$store.commit('session/toggleMobileMenu', false)"
  >
    <span
      class="icon"
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 24 24"
        :width="iconSize"
        :height="iconSize"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect
          x="3"
          y="5"
          width="18"
          height="16"
          rx="2"
        />
        <path d="M16 3v4M8 3v4M3 10h18M8 15l2.5 2.5L16 13" />
      </svg>
    </span>
    <span class="name">My Plan</span>
  </router-link>
</template>

<script>
export default {
  props: {
    // Icon-first layout for the mastery sidebar's narrow rail
    rail: {
      type: Boolean,
      default: false,
    },
    // Full-width row for the mobile menus
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    visible() {
      return !!this.$store.getters['user/get'] && this.$store.getters['studyPlan/enabled'];
    },
    active() {
      return this.$route.name?.startsWith('studyPlanner#');
    },
    mastery() {
      return this.$store.getters['app/isMasteryApp'];
    },
    iconSize() {
      if (this.rail) return 24;
      return this.mobile ? 20 : 18;
    },
  },
};
</script>

<style lang="scss" scoped>
  .study-planner-sidebar-link {
    align-items: center;
    border-radius: 4px;
    color: #C3CAD3;
    display: flex;
    gap: rem-calc(8);
    margin-bottom: rem-calc(4);
    min-height: rem-calc(37);
    padding: 0 rem-calc(12);
    text-decoration: none;

    &:hover {
      background-image: linear-gradient(to bottom, #2F3845, #252C35);
    }

    &.active {
      background-image: linear-gradient(-180deg, rgba(81, 97, 115, .48) 3%, rgba(59, 72, 87, .48) 98%);
      color: #FFF;
    }

    .icon {
      display: flex;
    }

    .name {
      font-size: rem-calc(12);
      font-weight: $semi-bold;
    }

    &.mastery {
      color: var(--text-tertiary);

      &:hover,
      &.active {
        background: #F1ECFE;
        color: var(--text-primary);
      }
    }

    &.rail {
      flex-direction: column;
      gap: rem-calc(4);
      height: auto;
      min-height: 0;
      padding: rem-calc(8) 0;
      width: 100%;

      &:hover,
      &.active {
        background: transparent;
      }

      .name {
        display: none;
        font-weight: $normal;
        text-align: center;
      }
    }

    &.mobile {
      color: inherit;
      min-height: 0;
      padding: 0;

      &:hover,
      &.active {
        background: transparent;
      }

      .name {
        font-size: inherit;
        font-weight: inherit;
      }
    }
  }
</style>
